import React, { useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { apiCall } from "../../../../../_services/apiCall";
import config from "../../../../../config/config";

const ResendInvitationModal = ({ show, supplierId, onClose, onSuccess }) => {
  const [sending, setSending] = useState(false);

  const handleClose = () => {
    if (sending) return;
    onClose();
  };

  const handleResend = async () => {
    if (!supplierId) return;
    setSending(true);
    const { isSuccess } = await apiCall(
      `${config.POSTLOGIN_API_URL_COMPANY}suppliers/resend-invitation`,
      {},
      { supplier_ids: [supplierId] },
      "POST"
    );
    setSending(false);
    if (isSuccess) {
      onSuccess?.();
      onClose();
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      backdrop={sending ? "static" : true}
      keyboard={!sending}
    >
      <Modal.Header closeButton style={{ borderBottom: "1px solid var(--rule)" }}>
        <Modal.Title style={{ fontSize: 17, fontWeight: 800, color: "var(--ink)" }}>
          Resend invitation?
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ fontSize: 14, color: "var(--ink-2)" }}>
        Are you sure you want to resend the invitation email to this supplier?
      </Modal.Body>
      <Modal.Footer style={{ borderTop: "1px solid var(--rule)", gap: 8 }}>
        <button
          type="button"
          className="kpi-btn-secondary"
          onClick={handleClose}
          disabled={sending}
        >
          Cancel
        </button>
        {sending ? (
          <button type="button" className="kpi-btn-primary" disabled>
            <Spinner animation="border" size="sm" className="me-1" />
            Sending…
          </button>
        ) : (
          <button type="button" className="kpi-btn-primary" onClick={handleResend}>
            Resend
          </button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default ResendInvitationModal;
